import React, { useCallback, useState } from "react";
import styles from "./styles.module.css";
import { useNavigate } from "react-router-dom";
import { useDeviceType } from "hooks";
import { theme } from "constants/theme";
import { Navbar } from "components/navbar/index";
import { NavId } from "types/navigation";
import back from "assets/images/back-icon.png";
import greenBack from "assets/images/green-back-icon.png";
import { Modal } from "components/modal";
import { addBlog } from "services/blogService";
import { CustomHeadline } from "components/ui";
import ArticleForm from "../ArticleForm/ArticleForm";
import { Blog } from "types/blog";
import moment from "moment";
import { PreviewArticle } from "../preview-article/preview-article";

interface NewArticlePageProps {
  handleClose: (sectionId: string, sectionNumber: number) => void;
}

export const NewArticle: React.FC<NewArticlePageProps> = ({ handleClose }) => {
  const [translate, setTranslate] = useState(0);
  const [activeSection, setActiveSection] = useState<number>(0);
  const [isHovered, setIsHovered] = useState(false);
  const { device } = useDeviceType();
  const isDesktop = device === "desktop";
  const navigate = useNavigate();

  const [singleBlog, setSingleBlog] = useState<Blog | null>({
    title: "",
    slug: "",
    status: "draft",
    description: "",
    customEditor: {},
    bulletPoints: [],
    desktopPreviewImageUrl: "",
    desktopInnerImageUrl: "",
    mobilePreviewImageUrl: "",
    mobileInnerImageUrl: "",
    date: moment(new Date()).format("YYYY-MM-DD"),
  });

  const [previewBlog, setPreviewBlog] = useState(false);
  const [previewBlogData, setPreviewBlogData] = useState<Blog | null>({
    title: "",
    slug: "",
    status: "draft",
    description: "",
    customEditor: {},
    bulletPoints: [],
    desktopPreviewImageUrl: "",
    desktopInnerImageUrl: "",
    mobilePreviewImageUrl: "",
    mobileInnerImageUrl: "",
    date: moment(new Date()).format("YYYY-MM-DD"),
  });

  const navigateToTop = useCallback(() => {
    if (device === "desktop") {
      document
        .getElementById(NavId.Section4)
        ?.scrollIntoView({ behavior: "smooth" });
      return;
    }
    setTranslate(0);
    setActiveSection(0);
  }, [device]);

  const resetValue = () => {
    setSingleBlog(null);
    setPreviewBlogData(null);
    localStorage.removeItem("editorContent");
  };

  const handleSubmit = async (blog: Blog) => {
    await addBlog(blog)
      .then((res) => {
        navigate(`/admin-article?status=${blog.status}`);
        resetValue();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  return (
    <>
      {previewBlog && previewBlogData ? (
        <PreviewArticle
          singleBlog={{
            ...previewBlogData,
          }}
          setPreviewBlog={setPreviewBlog}
          setSingleBlog={setSingleBlog}
        />
      ) : (
        <div className={styles.newArticle}>
          <Navbar
            activeSection={activeSection}
            navigateToTop={navigateToTop}
            theme="black"
            logoVariant="noLogoText"
            blur
          />
          <Modal
            setTranslate={setTranslate}
            setActiveSection={setActiveSection}
          />
          <div className={styles.container}>
            <img
              src={isHovered ? greenBack : back}
              alt="img"
              className={styles.closeButton}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
              onClick={() => {
                navigate(`/admin-article`);
                resetValue();
              }}
            />

            <div className={styles.content}>
              <CustomHeadline
                size={isDesktop ? 55 : 24}
                text="New Article"
                color={theme.colors.neutral[20]}
                styles={{
                  lineHeight: `${isDesktop ? 52 : 26}px`,
                  marginBottom: "30px",
                }}
              />
              {singleBlog && (
                <ArticleForm
                  existingBlog={singleBlog}
                  onSubmitMock={handleSubmit}
                  previewBlog={previewBlog}
                  previewBlogData={previewBlogData}
                  setPreviewBlog={setPreviewBlog}
                  setPreviewBlogData={setPreviewBlogData}
                />
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};
